module.exports = __webpack_public_path__ + "files/01429edb2a9e9d4c36dabd2ae93ca14d.png";